import { createFileRoute } from '@tanstack/react-router'

import { SpecScreen } from '@/features/specs/spec-screen'

/** One exact car: its listings, sales, nearest specs and the vehicle's other specs. */
export const Route = createFileRoute('/_app/platform/market/specs/$specKey')({
  component: SpecScreen,
})
